module.exports = __webpack_public_path__ + "img/backIconRight.9d306644.png";